module.exports = __webpack_public_path__ + "img/ligdata-logo-dark.3699e361.png";